import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import GetCustomersHaveEmail        from "../../../../../application/usecase/customer/GetCustomersHaveEmail";
import Customers                    from "../../../../../domain/customer/Customers";
import { ResKaState }               from "../../../../../index";
import ListPagination               from "../../../common/ListPagination";

const MailGroupCustomersPagination: FC = () => {
  const customers: Customers = useSelector((state: ResKaState) => state.customers);
  const getCustomersHaveEmail: GetCustomersHaveEmail = new GetCustomersHaveEmail(useDispatch());
  return (
    <>
      <ListPagination
        currentPage={ customers.pagination.current }
        totalPage={ customers.pagination.total }
        onChangePage={ currentPage => getCustomersHaveEmail.execute(currentPage, customers.search) }
      />
    </>
  );
};

export default MailGroupCustomersPagination;
